import { render, staticRenderFns } from "./RegistrarOrdenVenta.vue?vue&type=template&id=7c0bafc8&scoped=true&"
import script from "./RegistrarOrdenVenta.vue?vue&type=script&lang=js&"
export * from "./RegistrarOrdenVenta.vue?vue&type=script&lang=js&"
import style0 from "./RegistrarOrdenVenta.vue?vue&type=style&index=0&id=7c0bafc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0bafc8",
  null
  
)

export default component.exports